import { render } from "./ItemCategoriaSide.vue?vue&type=template&id=09eda140&scoped=true"
import script from "./ItemCategoriaSide.vue?vue&type=script&lang=js"
export * from "./ItemCategoriaSide.vue?vue&type=script&lang=js"

import "./ItemCategoriaSide.vue?vue&type=style&index=0&id=09eda140&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09eda140"]])

export default __exports__